module.exports = "<div id=\"test-drive-popup\">\n  <div class=\"test-drive-popup__content\">\n    <span ng-click=\"vm.close()\" class=\"test-drive-popup__close\">&times;</span>\n    <course-video lecture-title=\"''\" video-link=\"vm.videoUrl\" video-title=\"''\"></course-video>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/popups/dashboard/test-drive-popup/test-drive-popup.html
// module id = 1495
// module chunks = 0